import {connect} from "react-redux";
import CreateMrf from "./Mrf";
import {bindActionCreators} from "redux";
import {
    siteData,
    siteDataBySiteNo,
    getmaterial,
    getCategoryBrand,
    getCategoryData,
    associateMaterial,
    saveMaterial,
    materialTypes,
    getReportee,
    getWarehouse,
    getToEmployee,
    getStoreAddress,
    getErpInventory
} from "../../../services/redux/MaterialRequistionForm/action";
import {
    locationPinCode,
} from "services/redux/sales/corporate/locations/action";
import {documentUploadUrlPublic} from 'services/redux/fileUpload/action';
import { getBrandById } from "services/redux/sales/postSales/corporate/action";

const mapStateToProps = (state) => ({
    siteDetails: state.MaterialRequistionForm.siteDetails,
    siteByNo: state.MaterialRequistionForm.siteByNo,
    MaterialData: state.MaterialRequistionForm.MaterialData,
    BrandData: state.MaterialRequistionForm.BrandData,  
    CategoryData: state.MaterialRequistionForm.CategoryData,  
    associateMaterialDetails: state.MaterialRequistionForm.associateMaterial,
    pincodeData: state.locationReducer.pincodeData,
    savedMaterialRes: state.MaterialRequistionForm.savedMaterial,
    materialTypesRes: state.MaterialRequistionForm.materialTypes,
    reportee: state.MaterialRequistionForm.reportee,
    warehouseRes: state.MaterialRequistionForm.warehouse,
    toEmployee: state.MaterialRequistionForm.toEmployee,
    storeAddress: state.MaterialRequistionForm.storeAddress,
    erpInventory: state.MaterialRequistionForm.erpInventory,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            siteData,
            siteDataBySiteNo,
            getmaterial,
            getCategoryBrand,
            getCategoryData,
            getBrandById,
            associateMaterial,
            locationPinCode,
            saveMaterial,
            materialTypes,
            documentUploadUrlPublic,
            getReportee,
            getWarehouse,
            getToEmployee,
            getStoreAddress,
            getErpInventory
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CreateMrf);
